import { render, staticRenderFns } from "./BaseEtymNewEdit.vue?vue&type=template&id=3fa845f2&scoped=true&"
import script from "./BaseEtymNewEdit.vue?vue&type=script&lang=js&"
export * from "./BaseEtymNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa845f2",
  null
  
)

export default component.exports